<template>
    <Form v-bind="$attrs" v-on="$listeners" populateType="chain">
        <field-group
            v-for="(item, index) in list"
            :key="index"
            :model="item"
            class="flex dfl-item"
        >
            <!-- 日期 -->
            <FormItem prop="startTime">
                <DatePicker
                    v-model="item.startTime"
                    type="date"
                    style="width: 100%"
                />
            </FormItem>
            <div class="dfl-txt">至</div>
            <FormItem prop="endTime">
                <DatePicker
                    v-model="item.endTime"
                    type="date"
                    style="width: 100%"
                />
            </FormItem>
            <!-- 价格 -->
            <div class="dfl-txt">优惠</div>
            <FormItem prop="amount">
                <input-number
                    v-model="item.amount"
                    type="date"
                    style="width: 100%"
                />
            </FormItem>
            <!-- 删除 -->
            <span class="dfl-cut" @click="onCut(index)">-</span>
        </field-group>
        <div style="line-height: 0">
            <div class="dfl-add" @click="onAdd">
                <span class="dfl-add-plus">+</span>添加费用
            </div>
        </div>
    </Form>
</template>

<script>
function createItem() {
    return {
        startTime: '',
        endTime: '',
        amount: '',
    }
}

export default {
    name: 'demo-fee-list',
    inheritAttrs: false,
    data() {
        return {
            list: [],
        }
    },
    methods: {
        // 新增
        onAdd() {
            this.list.push(createItem())
        },
        // 删除
        onCut(i) {
            this.list.splice(i, 1)
        },
    },
}
</script>

<style lang="less" scoped>
.dfl {
    &-item {
        margin-bottom: 24px;
    }
    &-txt {
        padding: 0 10px;
    }
    &-cut {
        display: inline-block;
        line-height: 0;
        padding: 14px 10px;
        margin-left: 12px;
        display: inline-block;
        border: 1px solid #ccc;
        border-radius: 4px;
        background: #fff;
        font-size: 18px;
        cursor: pointer;
    }
    &-add {
        display: inline-block;
        cursor: pointer;
        line-height: 14px;

        &-plus {
            line-height: 12px;
            padding: 0 2px;
            margin-right: 2px;
            display: inline-block;
            border: 1px solid #ccc;
            border-radius: 4px;
            background: #fff;
        }
    }
}
</style>
